module.exports = __webpack_public_path__ + "static/media/close-gray.0f610249.svg";